import { render, staticRenderFns } from "./HMSVitalsPopUp.vue?vue&type=template&id=1378251e&scoped=true&"
import script from "./HMSVitalsPopUp.vue?vue&type=script&lang=js&"
export * from "./HMSVitalsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./HMSVitalsPopUp.vue?vue&type=style&index=0&id=1378251e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1378251e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1378251e')) {
      api.createRecord('1378251e', component.options)
    } else {
      api.reload('1378251e', component.options)
    }
    module.hot.accept("./HMSVitalsPopUp.vue?vue&type=template&id=1378251e&scoped=true&", function () {
      api.rerender('1378251e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HMS/Vitals/HMSVitalsPopUp.vue"
export default component.exports